export const UPDATE_SEARCHLIST = 'trainingMasterModuleSearch/updateResults'
export const RESET_FILTERS = 'trainingMasterModuleSearch/reset'
export const RESET_RESULTS = 'trainingMasterModuleSearch/resetTableData'
export const UPDATE_CONTROL_NO = 'trainingMasterModuleAdd/getControlNo'
export const GET_DETAIL = 'trainingMasterModule/getDetails'
export const SET_CONFIRM_MODAL = 'trainingMasterModuleSearch/setConfirmModal'
export const HIDE_CONFIRM_MODAL = 'trainingMasterModuleSearch/hideConfirmModal'
export const SHOW_CONFIRM_MODAL = 'trainingMasterModuleSearch/showConfirmModal'

// SEARCH FILTER TYPES
export const APPLY_FILTERS = 'trainingMasterModuleSearch/applySearchFilter'
export const CHG_FILTER_DATA = 'trainingMasterModuleSearch/changeFilterField'
export const CHG_FILTER_PAGE = 'trainingMasterModuleSearch/changePage'
export const CHG_FILTER_PAGE_SIZE = 'trainingMasterModuleSearch/changePageSize'
export const CHG_FILTER_SORT = 'trainingMasterModuleSearch/changeSortModel'
export const IS_LOADING = 'trainingMasterModuleSearch/isLoading'
export const CHG_SELECTED_ROWS = 'trainingMasterModuleSearch/changeSelected'
export const HIDE_LIST_ALERT = 'trainingMasterModuleSearch/hideAlert'
export const SET_LIST_ALERT = 'trainingMasterModuleSearch/setAlertModal'

// ADD FORM TYPES
export const CHG_FIELD = 'trainingMasterModuleAdd/changeField'
export const CHG_STATUS = 'trainingMasterModuleAdd/changeStatus'
export const CHG_EMPLOYEE_ID = 'trainingMasterModuleAdd/changeEmployeeId'
export const CHG_INCOME_ID = 'trainingMasterModuleAdd/changeIncomeId'
export const CHG_AMOUNT = 'trainingMasterModuleAdd/changeAmount'
export const CHG_EFFECTIVE_DATE = 'trainingMasterModuleAdd/changeEffectiveData'
export const CHG_MEMO = 'trainingMasterModuleAdd/changememo'
export const RESET_ADD_DATA = 'trainingMasterModuleAdd/reset'
export const UPD_ADD_ALERT = 'trainingMasterModuleAdd/updateAlert'
export const HIDE_ADD_ALERT = 'trainingMasterModuleAdd/hideAlert'
export const UPD_ADD_MEMO_CHAR_COUNT = 'trainingMasterModuleAdd/updateMemoCharCount'
export const INSERT_LOADING = 'trainingMasterModuleAdd/isLoading'
export const SET_ADD_DATA = 'trainingMasterModuleAdd/setAddData'
export const CHANGE_UPDATE_VALUES = 'trainingMasterModuleAdd/changeUpdateValues'
export const FETCH_TRAINING_VALUES = 'trainingMasterModuleAdd/fetchTrainingValues'

// DETAIL FORM TYPES
export const UPD_DETAIL_TITLE = 'trainingMasterModuleDetail/changeTitle'
export const RESET_DETAIL_DATA = 'trainingMasterModuleDetail/reset'
export const CHG_DETAIL_DATA = 'trainingMasterModuleDetail/changeFieldData'
export const UPD_DETAIL_MODE = 'trainingMasterModuleDetail/changeMode'
export const HAS_DETAIL_LOADED = 'trainingMasterModuleDetail/hasDetailLoaded'
export const SET_DETAIL_DATA = 'trainingMasterModuleDetail/setDetailData'
export const UPD_AMOUNT = 'trainingMasterModuleDetail/changeAmount'
export const UPD_DETAIL_MEMO_CHAR_COUNT = 'trainingMasterModuleDetail/updateMemoCharCount'
export const UPD_DETAIL_DATA = 'trainingMasterModuleDetail/updateDetailData'
export const SET_DETAIL_CONFIRM_MODAL = 'trainingMasterModuleDetail/setConfirmModal'
export const HIDE_DETAIL_CONFIRM_MODAL = 'trainingMasterModuleDetail/hideConfirmModal'
export const SHOW_DETAIL_CONFIRM_MODAL = 'trainingMasterModuleDetail/showConfirmModal'
export const SET_DETAIL_ALERT = 'trainingMasterModuleDetail/setAlertModal'
export const HIDE_DETAIL_ALERT = 'trainingMasterModuleDetail/hideAlert'


